import * as React from 'react';
import { Button, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { ActionWidget, CounterWidget, DelayWidget, RandomizerWidget } from 'components/form/trident-campaigns';
import './FlowDesign.scss';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import './WidgetComponent.scss';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import { getNodeTypeChildOptions } from 'components/form/trident-campaigns/util';

export default class ConditionWidget extends React.Component<CampaignWidgetProps> {
  isChildAllowed(allowedChildNodes: Array<string>, child: String) {
    return _.isEmpty(allowedChildNodes) || allowedChildNodes.includes(child);
  }

  render() {
    const { model, canActivate, currentNodeKey, parentKeyList } = this.props;
    const buttonStylee = {
      width: 150,
      height: 60,
      borderRadius: 10,
      border: '1px solid #8bc4fd',
      backgroundColor: '#e7f7ff',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const buttonStyleeClicked = {
      width: 150,
      height: 60,
      borderRadius: 10,
      border: '1px solid #4aadfc',
      backgroundColor: '#b6e3fe',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const addButtonSize = {
      fontSize: '1.5em',
      color: '#3498DB',
    };
    // check whether lastOccurrence is enabled at condition node or not
    let isLastOccurrence = false;
    if (_.get(model.nodes[currentNodeKey], 'recordLastOccurrenceKey')) isLastOccurrence = true;

    // code to decide whether 'add node button'(+ button) needs to be render or not.
    const renderAddButton = _.get(model.nodes[currentNodeKey], 'children', []).length === 0;

    // preparing ancestor list of current clicked node to send it into node preview display.
    const ancestorList = _.concat(parentKeyList, currentNodeKey);
    const parentKey = parentKeyList[parentKeyList.length - 1];
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.condition, _.get(model, 'nodesOccMap'));

    const allowedChildNodes = getNodeTypeChildOptions(model.targetUserType, nodeTypes.condition);

    return (
      <div className={_.get(this.props.model.nodes[parentKey], 'children', []).length > 1 ? 'entry' : 'entry sole'}>
        <span className="wrapDesign">
          <Popup
            trigger={
              <span>
                <Button style={this.props.clickedNode === this.props.currentNodeKey ? buttonStyleeClicked : buttonStylee} onClick={() => this.props.handleNodePreview(ancestorList, currentNodeKey)}>
                  {_.get(model.nodes[currentNodeKey], 'name', defaultName) || defaultName}
                </Button>
                {isLastOccurrence &&
                  <div className="lastTimeOccurrencee">
                    {_.get(model.nodes[currentNodeKey], 'recordLastOccurrenceKey')}
                  </div>
                }
              </span>
            }
            content={getNodePopupContent(model, 'name', currentNodeKey, defaultName)}
          />
          {renderAddButton &&
            <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
              <Dropdown.Menu>
                {this.isChildAllowed(allowedChildNodes, 'actions') &&
                   <Dropdown.Item onClick={() => this.props.handleAddNode('actions', currentNodeKey, ancestorList)}>
                     Add Action
                     {<Popup
                       trigger={<Icon name="info circle" />}
                       content="Add Action"
                       size="mini"
                     />}
                   </Dropdown.Item>
                }
                {this.isChildAllowed(allowedChildNodes, 'count') &&
                   <Dropdown.Item onClick={() => this.props.handleAddNode('count', currentNodeKey, ancestorList)}>
                     Add Counter
                     {<Popup
                       trigger={<Icon name="info circle" />}
                       content="Add Counter"
                       size="mini"
                     />}
                   </Dropdown.Item>
                }
                {this.isChildAllowed(allowedChildNodes, 'delay') &&
                   <Dropdown.Item onClick={() => this.props.handleAddNode('delay', currentNodeKey, ancestorList)}>
                     Add Delay
                     {<Popup
                       trigger={<Icon name="info circle" />}
                       content="Add Delay"
                       size="mini"
                     />}
                   </Dropdown.Item>
                }
                {this.isChildAllowed(allowedChildNodes, 'randomizer') &&
                     <Dropdown.Item onClick={() => this.props.handleAddNode('randomizer', currentNodeKey, ancestorList)}>
                     Add Randomizer
                       {<Popup
                         trigger={<Icon name="info circle" />}
                         content="Add Randomizer"
                         size="mini"
                       />}
                     </Dropdown.Item>
                }
              </Dropdown.Menu>
            </Dropdown>
          }
        </span>
        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 &&
          <div className="branch lv1">
            {_.get(model.nodes[currentNodeKey], 'children', []).map((childKey, index) => {
              if (model.nodes[childKey].type === 'count') {
                return (
                  <CounterWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    parentKeyList={ancestorList}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (model.nodes[childKey].type === 'delay') {
                return (
                  <DelayWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    parentKeyList={ancestorList}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (model.nodes[childKey].type === 'randomizer') {
                return (
                  <RandomizerWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    model={model}
                    canActivate={canActivate}
                    currentNodeKey={childKey}
                    parentKeyList={ancestorList}
                    onModelChange={this.props.onModelChange}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              return (
                <ActionWidget
                  key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                  onModelChange={this.props.onModelChange}
                  model={model}
                  currentNodeKey={childKey}
                  canActivate={canActivate}
                  parentKeyList={ancestorList}
                  handleNodePreview={this.props.handleNodePreview}
                  clickedNode={this.props.clickedNode}
                />
              );
            })}
          </div>
        }
      </div>
    );
  }
}
